import {
	Button,
	Container,
	Dialog,
	DialogActions,
	IconButton,
	ImageList,
	ImageListItem,
	Stack,
	Typography,
	AppBar,
	Toolbar,
	Box,
	Modal,
	DialogTitle,
	Tooltip,
	Avatar,
	Card,
	DialogContent,
	Paper,
	Select,
	MenuItem,
	TableCell,
	TableBody,
	TableHead,
	Table,
	TableContainer,
	TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import React, { useEffect, useState, useContext, useRef } from "react";
import axios from "axios";
import { get_inspection_list, get_issues_list, getfile, getLookupData, getOrderDataByID, imageURL } from "../../constant/url";
import { AccessContext } from "../../constant/accessContext";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
// import html2pdf from 'html2pdf.js';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';

// import { usePDF } from 'react-to-pdf';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PreviewIcon from "@mui/icons-material/Preview";
import Slide from "@mui/material/Slide";
import "../../Table.css";
import logo from "../../assets/img/sc-straight.jpeg";
import AutoCompleteOrder from "../Component/AutoCompleteOrder";
import UniversalFileViewer from "./Fileviewer";
import { CheckCircle } from "@mui/icons-material";
// import { jsPDF } from "jspdf";
// import { useReactToPrint } from 'react-to-print';
// import { useSelector } from "react-redux";

import quality1 from "../../assets/img/appIcons/Qualitym1.png";
import { DataGrid } from "@mui/x-data-grid";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function OrderViewModal(prop) {

	let orderRowID = prop.orderId;

	// const access = useSelector((state) => state.auth?.accessCode);
	const access = useContext(AccessContext).authID;

	let dateObj = new Date();
	const [orderNo, setOrderNo] = useState();
	const [splitId, setSplitId] = useState();
	const [orderDate, setOrderDate] = useState(
		dateObj.getDate() + "/" + dateObj.getMonth() + "/" + dateObj.getFullYear()
	);
	const [customerName, setCustomerName] = useState([]);
	const [length, setLength] = useState(null);
	const [height, setHeight] = useState(null);
	const [row, setRow] = useState(null);
	const [quantity, setQuantity] = useState(null);
	const [sqfeet, setSqFeet] = useState(0);
	const [size, setSize] = useState(0);
	const [pipeType, setPipeType] = useState("");
	const [expansionType, setExpansionType] = useState("");
	//New Pipe Bend components
	const [pbStraight, setPBStraight] = useState(false);
	const [pbStraightQty, setPBStraightQty] = useState(0);
	const [pbStraightSize, setPBStraightSize] = useState(0);
	const [pbStraightTotQty, setPBStraightTotQty] = useState(0);
	const [quality, setQuality] = useState("");

	const [qualityStatus, setQualityStatus] = useState("");

	const [pbSingle, setPBSingle] = useState(false);
	const [pbSingleQty, setPBSingleQty] = useState(0);
	const [pbSingleSize, setPBSingleSize] = useState(0);
	const [pbSingleTotQty, setPBSingleTotQty] = useState(0);

	const [pbCross, setPBCross] = useState(false);
	const [pbCrossQty, setPBCrossQty] = useState(0);
	const [pbCrossSize, setPBCrossSize] = useState(0);
	const [pbCrossTotQty, setPBCrossTotQty] = useState(0);

	const [pbOther, setPBOther] = useState(false);
	const [pbOtherQty, setPBOtherQty] = useState(0);
	const [pbOtherSize, setPBOtherSize] = useState(0);
	const [pbOtherTotQty, setPBOtherTotQty] = useState(0);

	const [pipeComment, setPipeComment] = useState("");
	const [endPlateMaterial, setEndPlateMaterial] = useState("");
	const [endPlateModel, setEndPlateModel] = useState("");
	const [endPlateOrientation, setEndPlateOrientation] = useState([]);
	const [coverType, setCoverType] = useState([]);
	const [coverDetail, setCoverDetail] = useState([]);
	const [epComments, setEPComments] = useState("");
	const [finPerInch, setFinPerInch] = useState("");
	const [description, setDescription] = useState("");
	const [finComments, setFinComments] = useState("");
	const [circuitModels, setCircuitModels] = useState([]);
	const [noCircuit, setNoCircuit] = useState("");
	const [liquidLine, setLiquidLine] = useState("");
	const [dischargeLine, setDischargeLine] = useState("");
	const [brazingComments, setBrazingComments] = useState("");
	const [paintType, setPaintType] = useState([]);
	const [packingType, setPackingType] = useState([]);
	const [dispatchMode, setDispatchMode] = useState([]);
	const [dispatchComment, setDispatchComments] = useState("");
	const [finalComments, setFinalComments] = useState("");
	const [finalConcatComments, setFinalConcatComments] = useState("");
	const [epPhoto, setEpPhoto] = useState([]);
	const [epDate, setEndPlateMaterials] = useState([]);
	const [assemblyPhoto, setAssemblyPhoto] = useState([]);
	const [brazingPhoto, setBrazingPhoto] = useState([]);
	const [lookUpList, setLookupList] = React.useState([]);
	/**
	 * Coil Detail States
	 */
	const [cncNestingStatus, setCncNestingStatus] = useState([]);
	const [cncNestingDate, setCncNestingDate] = useState([]);
	const [cncNestingStatusDate, setCncNestingStatusDate] = useState([]);
	const [cncNestingPgm, setCncNestingPgm] = useState([]);
	const [cncPunchingStatus, setCncPunchingStatus] = useState([]);
	const [cncPunchingDate, setCncPunchingDate] = useState([]);
	const [bendingStatus, setBendingStatus] = useState([]);

	const [bendingDate, setBendingDate] = useState([]);

	const [tCuttingStatus, setTCuttingStatus] = useState([]);


	const [tCuttingRollNo, setTCuttingRollNo] = useState([]);
	const [tCuttingDate, setTCuttingDate] = useState([]);

	const [tCuttingDateTime, setTCuttingDateTime] = useState([]);

	const [qualityName, setQualityName] = useState("");


	const [finPunchStatus, setFinPunchStatus] = useState([]);
	const [finPunchDate, setFinPunchDate] = useState([]);
	const [finFoilNo, setFinFoilNo] = useState([]);
	const [brazingExpansion, setBrazingExpansion] = useState([]);
	const [brazingStatus, setBrazingStatus] = useState([]);
	const [brazingDate, setBrazingDate] = useState([]);
	const [caStatus, setCaStatus] = useState([]);
	const [caStatusDate, setCaStatusDate] = useState([]);
	const [ceStatus, setCeStatus] = useState([]);
	const [ceStatusDate, setCeStatusDate] = useState([]);
	const [ppStatus, setPpStatus] = useState([]);
	const [ppDate, setPPDate] = useState([]);
	const [ppStatusDate, setPpStatusDate] = useState([]);
	const [dispatchStatus, setDispatchStatus] = useState([]);
	const [dispatchDate, setDispatchDate] = useState([]);

	const [isUpdate, setIsUpdate] = useState(false);
	const [brazingDetails, setBrazingDetails] = useState([]);
	const [openImg, setOpenImg] = useState(false);
	const [dialogImg, setDialogImg] = useState("");
	const [brazingTestingImages, setBrazingTestingImages] = useState([]);
	const [coilNo, setCoilNo] = useState('');

	const [serialNo, setSerialNo] = useState('');

	const [qualityInspection, setQualityInspection] = useState([]);

	console.log(qualityInspection);

	console.log(serialNo);


	const handleClickOpenimg = (base64) => {
		setDialogImg(base64);
		setOpenImg(true);
	};

	const handleCloseImg = (response) => {
		setOpenImg(false);
	};

	const handleSqFeet = () => {
		setSqFeet(((length * height * row * quantity) / 144).toFixed(2));
	};

	const handleSize = () => {
		const len = length === null ? 0 : length;
		const heig = height === null ? 0 : height;
		const rowval = row === null ? 0 : row;
		const qty = quantity === null ? 0 : quantity;

		let x =
			String(len) +
			" x " +
			String(heig) +
			" x " +
			String(rowval) +
			"R - " +
			String(qty);
		setSize(x);
	};

	function handleGetLookup() {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);

		/**add photos */
		axios({
			method: "post",
			url: getLookupData,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				//handle success
				const res_data = response.data;
				if (res_data.status_code === 200) {
					setLookupList(res_data);
				} else {
					//console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				//handle error
				console.log(response);
			});
	}


	const addQualityInspection = (order_id, order_serial_no) => {
		setQualityInspection(prev => {
			// Check if the exact (order_id, order_serial_no) pair already exists
			const exists = prev.some(
				item =>
					item.order_id === order_id &&
					item.order_serial_no === order_serial_no
			);

			if (!exists) {
				return [...prev, { order_id, order_serial_no }];
			}

			// Don't add duplicate pair
			return prev;
		});
	};



	const handleOrderinfo1 = () => {
		var bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		bodyFormData.append("id", orderRowID);

		axios({
			method: "post",
			url: getOrderDataByID,
			data: bodyFormData,
			headers: { "Content-Type": "multipart/form-data" },
		})
			.then(function (response) {
				const res_data = response.data;
				if (res_data.status_code === 101) {
					toast("Api Aithentication failed. login again.");
				} else if (res_data.status_code === 200) {
					const ret_data_cd = res_data.data_orders;
					const res_data_inspection = res_data?.quality_inspection;
					console.log(ret_data_cd);


					console.log(ret_data_cd[0].pbStraightQty);
					console.log(ret_data_cd[0].pbStraightSize);

					setOrderNo(ret_data_cd[0].order_id);
					setSplitId(ret_data_cd[0].split_id);
					setOrderDate(ret_data_cd[0].order_date);
					setCustomerName(ret_data_cd[0].full_customer_name);
					setLength(ret_data_cd[0].length);
					setHeight(ret_data_cd[0].height);
					setRow(ret_data_cd[0].rows);
					setQuantity(ret_data_cd[0].quantity);
					setSqFeet(ret_data_cd[0].sq_feet);
					setPipeType(ret_data_cd[0].pipe_type);
					setExpansionType(ret_data_cd[0].expansion_type);

					setPBStraight(ret_data_cd[0].pbStraight);
					setPBStraightQty(ret_data_cd[0].pbStraightQty);
					setPBStraightSize(ret_data_cd[0].pbStraightSize);
					setPBStraightTotQty(ret_data_cd[0].pbStraightTotQty);

					setPBSingle(ret_data_cd[0].pbSingle);
					setPBSingleQty(ret_data_cd[0].pbSingleQty);
					setPBSingleSize(ret_data_cd[0].pbSingleSize);
					setPBSingleTotQty(ret_data_cd[0].pbSingleTotQty);

					setPBCross(ret_data_cd[0].pbCross);
					setPBCrossQty(ret_data_cd[0].pbCrossQty);
					setPBCrossSize(ret_data_cd[0].pbCrossSize);
					setPBCrossTotQty(ret_data_cd[0].pbCrossTotQty);

					setPBOther(ret_data_cd[0].pbOther);
					setPBOtherQty(ret_data_cd[0].pbOtherQty);
					setPBOtherSize(ret_data_cd[0].pbOtherSize);
					setPBOtherTotQty(ret_data_cd[0].pbOtherTotQty);

					setPipeComment(ret_data_cd[0].pipe_comment);
					setEndPlateMaterial(ret_data_cd[0].end_plate_material);
					setEndPlateModel(ret_data_cd[0].end_plate_modal);
					setEndPlateOrientation(ret_data_cd[0].end_plate_orientation);
					setCoverType(ret_data_cd[0].cover_type);
					setCoverDetail(ret_data_cd[0].cover_detail);
					setEPComments(ret_data_cd[0].ep_comments);
					setFinPerInch(ret_data_cd[0].fin_per_inch);
					setDescription(ret_data_cd[0].fin_description);
					setFinComments(ret_data_cd[0].fin_comments);
					setCircuitModels(ret_data_cd[0].circuit_models);
					setNoCircuit(ret_data_cd[0].circuit_no);
					setLiquidLine(ret_data_cd[0].liquid_line);
					setDischargeLine(ret_data_cd[0].discharge_line);
					setBrazingComments(ret_data_cd[0].brazing_comment);
					setPaintType(ret_data_cd[0].paint);
					setPackingType(ret_data_cd[0].packing_type);
					setDispatchMode(ret_data_cd[0].dispatch_mode);
					setDispatchComments(ret_data_cd[0].dispatch_comment);
					setFinalComments(ret_data_cd[0].final_comment);

					setEpPhoto(ret_data_cd[0].ep_photo);

					setEndPlateMaterials(ret_data_cd[0].ep_DateTime);

					setAssemblyPhoto(ret_data_cd[0].assembly_Photo);

					setBrazingPhoto(ret_data_cd[0].brazing_Photo);

					setCncNestingStatus(ret_data_cd[0].cnc_nesting_status);
					setCncNestingPgm(ret_data_cd[0].cnc_nesting_pgm_no);
					setCncNestingDate(ret_data_cd[0].cnc_nested);
					setCncNestingStatusDate(ret_data_cd[0].cnc_nesting_status_dt);
					setCncPunchingStatus(ret_data_cd[0].cnc_punching_status);
					setCncPunchingDate(ret_data_cd[0].cnc_punching_status_dt);
					setBendingStatus(ret_data_cd[0].bending_status);

					setBendingDate(ret_data_cd[0].bending_status_dt);

					setTCuttingRollNo(ret_data_cd[0].tcutting_roll_no);

					setTCuttingDate(ret_data_cd[0].tcutting_datetime);


					setTCuttingDateTime(ret_data_cd[0].tcutting_status_dt);


					setTCuttingStatus(ret_data_cd[0].tcutting_status);


					setFinPunchStatus(ret_data_cd[0].finpunch_status);
					setFinPunchDate(ret_data_cd[0].finpunch_status_dt);
					setFinFoilNo(ret_data_cd[0].finpunching_foilno);
					setBrazingStatus(ret_data_cd[0].brazing_status);
					setBrazingDate(ret_data_cd[0].brazing_status_dt);
					setBrazingExpansion(ret_data_cd[0].ce_status_dt);
					setCaStatus(ret_data_cd[0].ca_status);
					setCaStatusDate(ret_data_cd[0].ca_status_dt);
					setCeStatus(ret_data_cd[0].ce_status);
					setCeStatusDate(ret_data_cd[0].ce_status_dt);
					setPpStatus(ret_data_cd[0].pp_status);
					setPPDate(ret_data_cd[0].pp_datetime);
					setPpStatusDate(ret_data_cd[0].pp_status_dt);
					setDispatchStatus(ret_data_cd[0].dispatch_status);
					setDispatchDate(ret_data_cd[0].dispatch_status_dt);
					setBrazingDetails(ret_data_cd[0].brazing_details);
					setBrazingTestingImages(ret_data_cd[0].brazing_testing_Photo);
					setQuality(ret_data_cd[0].quality_status_dt);
					setQualityStatus(ret_data_cd[0].quality);

					setSerialNo(ret_data_cd[0].serial_no);

					setCoilNo(ret_data_cd[0].coil_serial_no);
					setQualityName(ret_data_cd?.[0]?.quality_modified_by || "");


					const uniquePairs = [];
					const seen = new Set();

					res_data_inspection.forEach(item => {
						const key = `${item.order_id}_${item.order_serial_no}`;
						console.log(key);
						if (!seen.has(key)) {
							seen.add(key);
							uniquePairs.push({ order_id: item.order_id, order_serial_no: item.order_serial_no });
						}
					});

					uniquePairs.forEach(pair => {
						addQualityInspection(pair.order_id, pair.order_serial_no);
					});



					return ret_data_cd;
				} else {
					//console.log(res_data.status_msg);
				}
			})
			.catch(function (response) {
				console.log(response);
			});
	};
	const sizeString = String(size ?? ''); // safely coerce to string
	const sizeNumber = parseInt(sizeString.split('-')[1], 10);
	// const sizeOptions = Array.from({ length: sizeNumber }, (_, i) => i + 1);
	const rawOrderId = orderNo || '';
	const cleanedOrderId = rawOrderId.replace(/\D/g, '');


	const sizeOptions = Array.from({ length: sizeNumber }, (_, i) => i + 1)
		.filter((serialNo) => {
			return qualityInspection.some(
				(item) =>
					item.order_id === cleanedOrderId &&
					item.order_serial_no == String(serialNo)
			);
		});





	console.log(serialNo)
	const serialNumberOptions = serialNo
		? serialNo
			.split(',')
			.filter(Boolean)
			.filter((id) =>
				qualityInspection.some(
					(item) =>
						item.order_id == cleanedOrderId && item.order_serial_no == id
				)
			)
		: [];


	console.log(serialNumberOptions)




	const generatePDF = async (orderNo) => {

		console.log(orderNo)

		const doc = new jsPDF({
			orientation: "portrait",
			unit: "mm",
			format: "a4",
		});

		try {
			const orderDetailsElement = document.getElementById("orderDetails");

			if (!orderDetailsElement) {
				console.error("Order details element not found");
				return;
			}


			const logoImg = new Image();
			logoImg.src = logo;
			await new Promise((resolve, reject) => {
				logoImg.onload = resolve;
				logoImg.onerror = (error) => {
					console.warn("Logo image failed to load:", error);
					resolve();
				};

				setTimeout(resolve, 3000);
			});

			let yPosition = 12;
			const margin = 10;
			const pageWidth = doc.internal.pageSize.getWidth();


			const addImagesToPDF = async (doc, images, yPosition, margin) => {
				const pageHeight = doc.internal.pageSize.getHeight();
				const pageWidth = doc.internal.pageSize.getWidth();
				const maxImageWidth = 65;
				const maxImageHeight = 35;

				let imageX = pageWidth - maxImageWidth - margin;


				if (yPosition === 20) {

					yPosition = 50;
				}

				for (const imgPath of images) {
					if (!imgPath) continue;

					const img = new Image();
					img.src = imageURL + imgPath;

					await new Promise((resolve) => {
						img.onload = resolve;
						img.onerror = () => {
							console.warn("Failed to load image:", imgPath);
							resolve();
						};
					});


					if (yPosition + maxImageHeight > pageHeight - 20) {
						doc.addPage();
						yPosition = 20;
					}


					doc.addImage(img, "JPEG", imageX, yPosition, maxImageWidth, maxImageHeight);

					yPosition += maxImageHeight + 10;
				}

				return yPosition;
			};



			const addHeaderToPage = () => {

				if (logoImg.complete && logoImg.naturalWidth !== 0) {
					const logoWidth = 70; // Width of the logo as you're setting it
					const logoHeight = 20; // Height of the logo as you're setting it
					const logoX = (pageWidth - logoWidth) / 2; // 

					doc.addImage(logoImg, 'PNG', logoX, 10, logoWidth, logoHeight);
				}
				return 40;
			};

			yPosition = addHeaderToPage();


			doc.setFontSize(16);
			doc.setFont("helvetica", "bold");
			doc.text("Order Details", margin, yPosition);
			yPosition += 3;


			const orderData = {
				"Order No": orderNo + (splitId || " "),
				"Date": orderDate || " ",
				"Customer": customerName || " ",
				"Size": size || " ",
				"Sq Feet": sqfeet || " "
			};

			doc.autoTable({
				startY: yPosition,
				head: [Object.keys(orderData)],
				body: [Object.values(orderData)],
				theme: 'grid',
				margin: { left: margin, right: margin },
				headStyles: { fillColor: [255, 255, 255], fontStyle: 'bold', textColor: [0, 0, 0] },
				styles: { overflow: 'linebreak', cellPadding: 3, lineWidth: 0.3, lineColor: [0, 0, 0] }
			});

			yPosition = doc.lastAutoTable.finalY + 6;


			if (yPosition > doc.internal.pageSize.getHeight() - 20) {
				doc.addPage();
				yPosition = addHeaderToPage();
			}

			const addSpecificationsSection = async (title, data, images) => {
				if (yPosition > doc.internal.pageSize.getHeight() - 50) {
					doc.addPage();
					yPosition = addHeaderToPage();
				}

				// Add section title
				doc.setFontSize(14);
				doc.setFont("helvetica", "bold");
				doc.text(title, margin, yPosition);
				yPosition += 3;

				// Table setup
				const tableWidth = pageWidth * 0.5;
				const body = Object.entries(data).map(([key, value]) => [key, value?.toString() || ""]);

				const tableStartY = yPosition;
				doc.autoTable({
					startY: tableStartY,
					body: body,
					theme: 'grid',
					margin: { left: margin, right: margin + tableWidth },
					styles: { overflow: 'linebreak', cellPadding: 3, lineWidth: 0.3, lineColor: [0, 0, 0] },
					columnStyles: { 0: { cellWidth: 35, fontStyle: 'bold', textColor: [0, 0, 0] } },
					tableWidth: tableWidth,
				});

				const tableEndY = doc.lastAutoTable.finalY;
				yPosition = tableEndY + 7;

				// Image handling — move images closer to the top
				if (images && images.length > 0) {
					const imageX = margin + tableWidth + 10;
					let imageY = tableStartY - 160;  // Adjust this value to move images closer to the top
					const maxImageWidth = 65;
					const maxImageHeight = 35;

					for (const imgPath of images) {
						if (!imgPath) continue;
						const img = new Image();
						img.src = imageURL + imgPath;

						await new Promise((resolve) => {
							img.onload = resolve;
							img.onerror = () => {
								console.warn("Failed to load image:", imgPath);
								resolve();
							};
							setTimeout(resolve, 1000);
						});

						if (img.complete && img.naturalWidth !== 0) {
							// Add new page if needed
							if (imageY + maxImageHeight > doc.internal.pageSize.getHeight() - 20) {
								doc.addPage();
								yPosition = addHeaderToPage();
								imageY = yPosition; // Reset to top of new page
							}
							doc.addImage(img, "JPEG", imageX, imageY, maxImageWidth, maxImageHeight);
							imageY += maxImageHeight + 10;  // Adjust spacing between images
						}
					}
				}

				return yPosition;
			};


			const endPlateData = {};


			if (lookUpList && lookUpList["epMaterial"] && endPlateMaterial) {
				endPlateData["Material"] = lookUpList["epMaterial"]
					.filter(item => endPlateMaterial.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (lookUpList && lookUpList["epModal"] && endPlateModel) {
				endPlateData["Model"] = lookUpList["epModal"]
					.filter(item => endPlateModel.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}


			if (lookUpList && lookUpList["oreientation"] && endPlateOrientation) {
				endPlateData["Orientation"] = lookUpList["oreientation"]
					.filter(item => endPlateOrientation.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (lookUpList && lookUpList["coverDetail"] && coverDetail) {
				endPlateData["Cover Type"] = lookUpList["coverDetail"]
					.filter(item => item && coverDetail.includes(item.id))
					.map(item => item.sublkp_val)
					.join(", ") || "N/A";
			}
			if (Object.keys(endPlateData).length > 0) {

				addSpecificationsSection("End Plate", endPlateData);
			}


			const pipeData = {};

			if (lookUpList && lookUpList["pipeType"] && pipeType) {
				pipeData["Pipe Type"] = lookUpList["pipeType"]
					.filter(item => pipeType.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}



			const pipeBendTypes = [];

			if (pbStraight === "true") pipeBendTypes.push("Straight");
			if (pbSingle === "true") pipeBendTypes.push("Single");
			if (pbCross === "true") pipeBendTypes.push("Cross");
			if (pbOther === "true") pipeBendTypes.push("Other");

			if (pipeBendTypes.length > 0) {
				pipeData["Pipe Bend"] = pipeBendTypes.join(", ");
			}

			if (Object.keys(pipeData).length > 0) {

				addSpecificationsSection("Pipe", pipeData);
			}


			if (finPerInch) {
				const finsData = {
					"Fin per Inch": finPerInch,
					"Fin Thickness": description || "N/A"
				};
				addSpecificationsSection("Fins", finsData);
			}

			const brazingData = {};

			if (lookUpList && lookUpList["circuitModel"] && circuitModels) {
				brazingData["Circuit Model"] = lookUpList["circuitModel"]
					.filter(item => circuitModels.indexOf(item.id) !== -1)
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (noCircuit) {
				brazingData["No of circuit"] = noCircuit;
			}

			if (lookUpList && lookUpList["liquidLine"] && liquidLine) {
				brazingData["Liquid Line"] = lookUpList["liquidLine"]
					.filter(item => liquidLine.indexOf(item.id) !== -1)
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (lookUpList && lookUpList["dischargeLine"] && dischargeLine) {
				brazingData["Discharge Line"] = lookUpList["dischargeLine"]
					.filter(item => dischargeLine.indexOf(item.id) !== -1)
					.map(item => item.lkp_value)
					.join(", ");
			}


			if (Object.keys(brazingData).length > 0) {
				addSpecificationsSection("Brazing", brazingData);
			}

			const paintData = {};

			if (lookUpList && lookUpList["paintType"] && paintType) {
				paintData["Paint"] = lookUpList["paintType"]
					.filter(item => paintType.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (lookUpList && lookUpList["packingType"] && packingType) {
				paintData["Packing"] = lookUpList["packingType"]
					.filter(item => packingType.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}

			if (lookUpList && lookUpList["dispatchMode"] && dispatchMode) {
				paintData["Dispatch"] = lookUpList["dispatchMode"]
					.filter(item => dispatchMode.includes(item.id))
					.map(item => item.lkp_value)
					.join(", ");
			}

			// if (Object.keys(paintData).length > 0) {
			// 	addSpecificationsSection("Paint, Packing and Dispatch", paintData);
			// }

			let endPlateImages = epPhoto?.length ? epPhoto : [];
			let assemblyImages = assemblyPhoto?.length ? assemblyPhoto : [];
			let brazingImages = brazingPhoto?.length ? brazingPhoto : [];
			let allImages = [...endPlateImages, ...assemblyImages, ...brazingImages];

			if (Object.keys(paintData).length > 0) {
				yPosition = await addSpecificationsSection("Paint, Packing and Dispatch", paintData, allImages);
			}


			doc.addPage();
			yPosition = addHeaderToPage();

			doc.setFontSize(16);
			doc.setFont("helvetica", "bold");
			doc.text("Coil Details", margin, yPosition);
			yPosition += 8;

			const formatDateIst = (dateString) => {
				if (!dateString) return " ";
				try {
					const date = new Date(dateString);
					return date instanceof Date && !isNaN(date)
						? date.toLocaleString('en-IN', {
							timeZone: 'Asia/Kolkata',
							day: '2-digit',
							month: '2-digit',
							year: 'numeric',
							hour: '2-digit',
							minute: '2-digit'
						})
						: "Invalid Date";
				} catch (error) {
					console.error("Date formatting error:", error);
					return "Error";
				}
			};


			const processDetails = [
				{ process: "CNC Nesting", date: formatDateIst(cncNestingDate), comments: "" },
				{ process: "CNC Program Created", date: formatDateIst(cncNestingStatusDate), comments: `Program Number-${cncNestingPgm || ""}` },
				{ process: "CNC end plate punching", date: formatDateIst(cncPunchingDate), comments: "" },
				{ process: "End plate bending", date: formatDateIst(bendingDate), comments: "" },
				{ process: "Tray/Fan Cover Bending", date: formatDateIst(bendingDate), comments: `Comments: ${epComments || ""}` },
				{ process: "Copper tube Cutting", date: formatDateIst(tCuttingDate), comments: `Roll Number: ${tCuttingRollNo || ""}` },
				{ process: "Copper tube Bending", date: formatDateIst(bendingDate), comments: `Comments: ${pipeComment || ""}` },
				{ process: "Fins Punching", date: formatDateIst(finPunchDate), comments: `Foil Number: ${finFoilNo || "No Roll No"}` },
				{ process: "Coil Assembly", date: formatDateIst(caStatusDate), comments: `Comments: ${finComments || ""}` },
				{ process: "Coil Expansion", date: formatDateIst(brazingExpansion), comments: `Expansion Type: ${lookUpList["expansionType"]?.filter(item => expansionType?.includes(item.id)).map(item => item.lkp_value).join(", ") || ""}` },
				{ process: "Coil Brazing & Leak Testing", date: formatDateIst(brazingDate), comments: `Comments: ${brazingComments || ""}` },
				{ process: "Painting", date: formatDateIst(ppDate), comments: `Painting Type: ${lookUpList["paintType"]?.filter(item => paintType?.includes(item.id)).map(item => item.lkp_value).join(", ") || ""}` },
				{ process: "Packing", date: formatDateIst(ppStatusDate), comments: `Packing Type: ${lookUpList["packingType"]?.filter(item => packingType?.includes(item.id)).map(item => item.lkp_value).join(", ") || ""}` },
				{ process: "Dispatch", date: formatDateIst(dispatchDate), comments: dispatchComment || "" }
			];

			doc.autoTable({
				startY: yPosition,
				head: [["Process", "Date & Time", "Comments"]],
				body: processDetails.map(item => [item.process, item.date, item.comments]),
				theme: 'grid',
				margin: { left: margin, right: margin },
				styles: { overflow: 'linebreak', cellPadding: 3, lineWidth: 0.3, lineColor: [0, 0, 0] },
				headStyles: { fillColor: [255, 255, 255], fontStyle: 'bold', textColor: [0, 0, 0] },
				columnStyles: {
					0: { cellWidth: 70, fontStyle: 'bold', textColor: [0, 0, 0] },
					1: { cellWidth: 50 },
				},

			});

			yPosition = doc.lastAutoTable.finalY + 10;



			// if (brazingDetails && brazingDetails.length > 0) {
			// 	doc.addPage();
			// 	yPosition = addHeaderToPage();

			// 	doc.setFontSize(16);
			// 	doc.setFont("helvetica", "bold");
			// 	doc.text("Brazing & Leak Testing Details", margin, yPosition);
			// 	yPosition += 10;


			// 	for (let i = 0; i < brazingDetails.length; i++) {
			// 		const detail = brazingDetails[i];

			// 		if (!detail) continue; // Skip if detail is undefined

			// 		if (yPosition > doc.internal.pageSize.getHeight() - 80) {
			// 			doc.addPage();
			// 			yPosition = addHeaderToPage();
			// 		}

			// 		doc.setFontSize(12);
			// 		doc.text(`Table ${i + 1}`, margin, yPosition);
			// 		yPosition += 5;


			// 		const leakDetailsArray = [];
			// 		if (detail.A && detail.A !== "0") leakDetailsArray.push(`A:${detail.A}`);
			// 		if (detail.B && detail.B !== "0") leakDetailsArray.push(`B:${detail.B}`);
			// 		if (detail.C && detail.C !== "0") leakDetailsArray.push(`C:${detail.C}`);
			// 		if (detail.D && detail.D !== "0") leakDetailsArray.push(`D:${detail.D}`);


			// 		const workmanDetailsArray = [];
			// 		if (detail.uBend) workmanDetailsArray.push(`U-Bend:${detail.uBend}`);
			// 		if (detail.inletOutlet) workmanDetailsArray.push(`Inlet-Outlet:${detail.inletOutlet}`);
			// 		if (detail.header) workmanDetailsArray.push(`Header:${detail.header}`);
			// 		if (detail.distributor) workmanDetailsArray.push(`Distributor:${detail.distributor}`);

			// 		const brazingData = {
			// 			"Serial No": detail.series_ref || "N/A",
			// 			"Leak Date": formatDateIst(detail.completion),
			// 			"Leak Details": leakDetailsArray.length > 0 ? leakDetailsArray.join(" ") : "None",
			// 			"Workman Details": workmanDetailsArray.length > 0 ? workmanDetailsArray.join(" ") : "None"
			// 		};

			// 		doc.autoTable({
			// 			startY: yPosition,
			// 			body: Object.entries(brazingData).map(([key, value]) => [key, value]),
			// 			theme: 'grid',
			// 			margin: { left: margin, right: margin },
			// 			styles: { overflow: 'linebreak', cellPadding: 3 },
			// 			columnStyles: { 0: { cellWidth: 50, fontStyle: 'bold' } },
			// 			tableWidth: 100
			// 		});

			// 		yPosition = doc.lastAutoTable.finalY + 15;


			// 		if (brazingTestingImages && brazingTestingImages[detail.series_id] &&
			// 			Array.isArray(brazingTestingImages[detail.series_id]) &&
			// 			brazingTestingImages[detail.series_id].length > 0) {

			// 			const images = brazingTestingImages[detail.series_id];

			// 			for (const imgPath of images) {
			// 				if (!imgPath) continue;  

			// 				try {
			// 					const img = new Image();
			// 					img.src = imageURL + imgPath;


			// 					await new Promise((resolve) => {
			// 						img.onload = resolve;
			// 						img.onerror = () => {
			// 							console.warn(`Failed to load image: ${imgPath}`);
			// 							resolve();
			// 						};
			// 						setTimeout(resolve, 1500);  
			// 					});


			// 					if (img.complete && img.naturalWidth !== 0) {
			// 						const imgWidth = 80;
			// 						const imgHeight = 60;

			// 						if (yPosition + imgHeight > doc.internal.pageSize.getHeight() - 20) {
			// 							doc.addPage();
			// 							yPosition = addHeaderToPage();
			// 						}

			// 						doc.addImage(img, 'JPEG', margin, yPosition, imgWidth, imgHeight);
			// 						yPosition += imgHeight + 10;
			// 					}
			// 				} catch (imgError) {
			// 					console.error("Error loading image:", imgError, imgPath);

			// 				}
			// 			}
			// 		}
			// 	}
			// }


			if (brazingDetails && brazingDetails.length > 0) {
				doc.addPage();
				yPosition = addHeaderToPage();

				doc.setFontSize(16);
				doc.setFont("helvetica", "bold");
				doc.text("Brazing & Leak Testing Details", margin, yPosition);
				yPosition += 5;

				for (let i = 0; i < brazingDetails.length; i++) {
					const detail = brazingDetails[i];

					if (!detail) continue;

					if (yPosition > doc.internal.pageSize.getHeight() - 80) {
						doc.addPage();
						yPosition = addHeaderToPage();
					}

					doc.setFontSize(12);
					doc.text(`Table ${i + 1}`, margin, yPosition);
					yPosition += 3;

					const leakDetailsArray = [];
					if (detail.A && detail.A !== "0") leakDetailsArray.push(`A:${detail.A}`);
					if (detail.B && detail.B !== "0") leakDetailsArray.push(`B:${detail.B}`);
					if (detail.C && detail.C !== "0") leakDetailsArray.push(`C:${detail.C}`);
					if (detail.D && detail.D !== "0") leakDetailsArray.push(`D:${detail.D}`);

					const workmanDetailsArray = [];
					if (detail.uBend) workmanDetailsArray.push(`U-Bend:${detail.uBend}`);
					if (detail.inletOutlet) workmanDetailsArray.push(`Inlet-Outlet:${detail.inletOutlet}`);
					if (detail.header) workmanDetailsArray.push(`Header:${detail.header}`);
					if (detail.distributor) workmanDetailsArray.push(`Distributor:${detail.distributor}`);

					const brazingData = {
						"Serial No": detail.series_ref || " ",
						"Leak Date": formatDateIst(detail.completion),
						"Leak Details": leakDetailsArray.length > 0 ? leakDetailsArray.join(" ") : " ",
						"Workman Details": workmanDetailsArray.length > 0 ? workmanDetailsArray.join(" ") : " "
					};

					doc.autoTable({
						startY: yPosition,
						body: Object.entries(brazingData).map(([key, value]) => [key, value]),
						theme: 'grid',
						margin: { left: margin, right: margin },
						styles: { overflow: 'linebreak', cellPadding: 3, lineWidth: 0.3, lineColor: [0, 0, 0] },
						columnStyles: { 0: { cellWidth: 50, fontStyle: 'bold', textColor: [0, 0, 0] } },
						tableWidth: 100,

					});

					let tableEndY = doc.lastAutoTable.finalY;
					let imageX = margin + 120;
					let imageY = yPosition;

					if (brazingTestingImages && brazingTestingImages[detail.series_id] &&
						Array.isArray(brazingTestingImages[detail.series_id]) &&
						brazingTestingImages[detail.series_id].length > 0) {

						const images = brazingTestingImages[detail.series_id];

						for (const imgPath of images) {
							if (!imgPath) continue;

							try {
								const img = new Image();
								img.src = imageURL + imgPath;

								await new Promise((resolve) => {
									img.onload = resolve;
									img.onerror = () => {
										console.warn(`Failed to load image: ${imgPath}`);
										resolve();
									};
									setTimeout(resolve, 1500);
								});

								if (img.complete && img.naturalWidth !== 0) {
									const imgWidth = 60;
									const imgHeight = 35;

									if (imageY + imgHeight > doc.internal.pageSize.getHeight() - 1) {
										doc.addPage();
										yPosition = addHeaderToPage();
										imageY = yPosition;
									}

									doc.addImage(img, 'JPEG', imageX, imageY, imgWidth, imgHeight);
									imageY += imgHeight + 10;
								}
							} catch (imgError) {
								console.error("Error loading image:", imgError, imgPath);
							}
						}
					}

					yPosition = Math.max(tableEndY, imageY) + 10;
				}
			}

			doc.save(`Order_${orderNo}.pdf`);
			return true;
		} catch (error) {
			console.error("Error generating PDF:", error);
			alert("Failed to generate PDF. Please try again.");
			return false;
		}
	};


	const handleSearchOrderId = (orderId) => {
		orderRowID = orderId.id;
		handleOrderinfo1();
	};

	const getThickValue = (finPerInch) => {
		console.log(finPerInch)
		const mapper = {
			T: "0.15mm Thick",
			H: "0.13mm Thick",
			B: "0.12mm Thick Hydrophilic blue Aluminum",
			C: "0.12mm Thick Copper Fins",
			S: "0.105mm Thick",
			U: "0.20mm Thick",
			H: "0.13mm Thick",
			I: "0.13mm Thick Hydrophilic Blue Aluminium",
			PP: "Not Applicable",
		};
		if (finPerInch.includes("-")) {
			finPerInch = finPerInch.split("-")[0].trim().toUpperCase();
		}
		if (typeof finPerInch === "string") {
			finPerInch = finPerInch.toUpperCase();
		}
		if (mapper[finPerInch]) {
			return mapper[finPerInch];
		} else {
			// If value is not found in mapper, return a default value
			return "0.12mm Thick"; // You can set your default value here
		}
	};


	const formatDateIst = (date) => {
		if (date != "" && date != null && date != "undefined") {
			const time = date.split(" ")[1] ?? "";
			let newDate = new Date(date);
			let month = newDate.getMonth() + 1;
			month = month < 10 ? "0" + month : month;
			return (
				newDate.getDate() +
				"-" +
				month +
				"-" +
				newDate.getFullYear() +
				" " +
				time
			);
		}
		return "";
	};


	useEffect(() => {
		handleSqFeet();
		handleSize();
	}, [length, height, row, quantity, handleSqFeet, handleSize]);

	useEffect(() => {
		if (prop.orderId !== null || prop.orderId !== 0) {
			handleGetLookup();
			handleOrderinfo1();
		}
	}, [prop.orderId]);
	const fixedLayout = {
		tableLayout: "fixed",
	};


	const [isModalVisible, setIsModalVisible] = useState(false);
	const [fileUrls, setFileUrls] = useState([]);

	const fetchFileUrl = async () => {
		try {
			const bodyFormData = new FormData();
			bodyFormData.append("authId", access);
			bodyFormData.append("order_id", orderNo + splitId);

			const response = await axios.post(getfile, bodyFormData, {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			});

			if (response?.data?.data?.length > 0) {
				const urls = response.data.data.map(item => item.file_name);
				setFileUrls(urls);
			} else {
				console.warn("No files returned.");
			}
		} catch (error) {
			console.error("Error fetching file:", error);
		}
	};


	const handleViewFile = async () => {
		await fetchFileUrl();
		setIsModalVisible(true);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};


	const getFileType = (url) => {
		if (url.endsWith('.pdf')) return 'pdf';
		if (url.endsWith('.doc') || url.endsWith('.docx')) return 'word';
		return 'image';
	};


	const [details, setDetails] = useState(null); // or an object, depending on your needs
	const [openDialog, setOpenDialog] = useState(false);

	const handleQualityCheckClick = () => {
		setOpenDialog(true);
		// handleOrderinfo1();
		fetchInspectionList();
		getIssuesList();
	};

	console.log(details);


	const [inputValue, setInputValue] = useState('');

	console.log(inputValue)


	const [inspectionList, setInspectionList] = useState([]);







	const fetchInspectionList = async () => {
		if (!inputValue) return; // Skip if empty

		try {
			const bodyFormData = new FormData();
			bodyFormData.append("authId", access);
			bodyFormData.append("order_id", cleanedOrderId);
			bodyFormData.append("coil_serial_no", inputValue);

			const response = await axios.post(get_inspection_list, bodyFormData);
			const data = response?.data?.data || [];
			setInspectionList(data);
		} catch (error) {
			console.error("Error fetching inspection list:", error);
		}
	};


	useEffect(() => {
		fetchInspectionList();
	}, [inputValue]); // 🔁 Triggers when `inputValue` changes



	const [modifiedBy, setModifiedBy] = useState([]); // An array of names
	console.log(modifiedBy)

	useEffect(() => {
		console.log("done");

		const names = inspectionList
			.map((item) => item.modified_by)
			.filter((name) => name !== null && name !== undefined && name !== "");

		const combined = qualityName ? [...names, qualityName] : names;

		setModifiedBy(Array.from(new Set(combined))); // 👈 directly set new state
	}, [inspectionList, qualityName]);




	const [issuesList, setIssuesList] = useState([]);

	const getIssuesList = async () => {
		const bodyFormData = new FormData();
		bodyFormData.append("authId", access);
		bodyFormData.append("order_id", cleanedOrderId);

		try {
			const response = await axios.post(get_issues_list, bodyFormData);
			if (response.data && response.data.data) {
				const issuesWithSno = response.data.data.map((item, index) => ({
					...item,
					sno: index + 1
				}));

				setIssuesList(issuesWithSno);
			}
		} catch (error) {
			console.log(error);
		}

	};


	useEffect(() => {
		const serialNo1 = serialNo;
		const coilSerialNo = coilNo;
		const firstSerial = serialNo1 && serialNo1.trim() !== ""
			? serialNo1.split(',').filter(s => s.trim() !== "")[0]?.trim()
			: coilSerialNo;
		setInputValue(firstSerial);
	}, [serialNo]);

	const rows = [
		// Endplate Section
		{
			description: 'Length',
			specification: length || '',
		},
		{

			description: 'Height',
			specification: height || '',
		},
		{

			description: 'Rows',
			specification: row || '',
		},
		{
			description: 'Endplate Material',
			specification: lookUpList["epMaterial"]
				?.filter(item => endPlateMaterial?.includes(item.id))
				.map(item => item.lkp_value)
				.join(", ") || "",
		},

		{

			description: 'Endplate Model',
			specification: lookUpList["epModal"]
				?.filter(item => endPlateModel?.includes(item.id))
				.map(item => item.lkp_value)
				.join(', ')
		},
		{

			description: 'Endplate Orientation',
			specification: lookUpList["oreientation"]?.map((item) => {
				return (
					<>
						{endPlateOrientation &&
							endPlateOrientation.includes(item.id)
							? item.lkp_value
							: ""}
						<br />
					</>
				);
			}),
		},
		{

			description: 'Cover Detail',
			specification: lookUpList["coverType"]?.map((item) => {
				return (
					<>
						{lookUpList["coverDetail"]?.map((itemd) => {
							if (
								coverDetail !== undefined &&
								itemd.lkp_id === item.id &&
								coverDetail.indexOf(itemd.id) !== -1
							) {
								return (
									<>
										{itemd.sublkp_val}
									</>
								);
							}
						})}
					</>
				);
			}),

		},

		// Pipe Section
		{

			description: 'Pipe Type',
			specification: lookUpList["pipeType"]?.map((item) => {
				return (
					<>
						{pipeType && pipeType.includes(item.id)
							? item.lkp_value
							: null}
					</>
				);
			}),
		},
		{

			description: 'Straight Pipe',
			specification: pbStraight === "true" && pbStraightQty && pbStraightSize
				? `${pbStraightQty}  , ${pbStraightSize}mm`
				: '',
		},
		{

			description: 'Single Pipe',
			specification: pbSingle === "true" && pbSingleQty && pbSingleSize
				? `${pbSingleQty}  , ${pbSingleSize}mm`
				: '',
		},
		{

			description: 'Cross Pipe',
			specification: pbCross === "true" && pbCrossQty && pbCrossSize
				? `${pbCrossQty}  , ${pbCrossSize}mm`
				: '',
		},
		{

			description: 'Other Pipe',
			specification: pbOther === "true" && pbOtherQty && pbOtherSize
				? `${pbOtherQty}  , ${pbOtherSize}mm`
				: '',
		},

		// Fin Section
		{

			description: 'Fins Per Inch',
			specification: finPerInch,
		},
		{

			description: 'Fin Thickness',
			specification: description
 || '',
		},


		// Assembly Section
		{

			description: 'After Coil Assembly (Drawing / Sample)',
		},
		// Brazing Section
		{

			description: 'Circuit',
			specification: lookUpList["circuitModel"]?.map((item) => {
				return (
					<>
						{circuitModels &&
							circuitModels.indexOf(item.id) !== -1
							? item.lkp_value
							: ""}
					</>
				);
			}),
		},
		{

			description: 'Feeding',
			specification: noCircuit,
		},
		{

			description: 'Liquid Line',
			specification: lookUpList["liquidLine"]?.map((item) => {
				return (
					<>
						{liquidLine &&
							liquidLine.indexOf(item.id) !== -1 &&
							item.lkp_value}
					</>
				);
			}),
		},
		{

			description: 'Discharge Line',
			specification: lookUpList["dischargeLine"]?.map((item) => {
				return (
					<>
						{dischargeLine &&
							dischargeLine.indexOf(item.id) !== -1
							? item.lkp_value
							: ""}
					</>
				);
			}),
		},
		{
			description: 'After Brazing (Drawing / Sample)',
		},

		// Packing Section
		{

			description: 'Paint Type',
			specification: lookUpList["paintType"]?.map((item) => {
				return (
					<>
						{paintType && paintType.includes(item.id)
							? item.lkp_value
							: ""}
					</>
				);
			}),
		},
		{

			description: 'Packing Type',
			specification: lookUpList["packingType"]?.map((item) => {
				return (
					<>
						{packingType && packingType.includes(item.id)
							? item.lkp_value
							: ""}
					</>
				);
			}),
		},
	];


	const evaluateSection = (statuses) => {
		const normalized = statuses.map(status => (status || '').toLowerCase().trim());

		// If any status is "not ok", fail the section
		if (normalized.includes('not ok')) {
			return 'Fail';
		}

		// If all statuses are acceptable, pass the section
		const allowed = ['ok', 'n/a', 'issue corrected'];
		const allAllowed = normalized.every(status => allowed.includes(status));

		return allAllowed ? 'Pass' : '';
	};


	// const [modifiedBy, setModifiedBy] = useState('');

	// console.log(modifiedBy)


	// Step 1: Enrich rows with inspection status
	const enrichedRows = rows.map((row) => {
		const match = inspectionList.find(
			(item) => item.measurement === row.description
		);



		// if (match?.modified_by) {
		// 	setModifiedBy(match.modified_by);
		// }

		return {
			...row,
			status: match?.status || '',
			finalStatus: match?.final_status || '',
			remarks: match?.remarks || '',
			section: match?.section || row.section || '',
		};
	});

	// Step 2: Group enriched rows by section
	const groupedRows = enrichedRows.reduce((acc, row) => {
		if (!acc[row.section]) acc[row.section] = [];
		acc[row.section].push(row);

		return acc;
	}, {});

	// Step 3: Assign section-level finalStatus
	const enrichedGroupedRows = Object.entries(groupedRows).reduce((acc, [section, sectionRows]) => {

		console.log(section);
		console.log(sectionRows);

		const statuses = sectionRows.map(row => row.status);
		const sectionFinalStatus = evaluateSection(statuses);

		acc[section] = sectionRows.map(row => ({
			...row,
			finalStatus: sectionFinalStatus,
		}));

		return acc;
	}, {});



	const handlePrintInspectionReport = () => {
		const doc = new jsPDF({
			orientation: 'portrait',
			unit: 'mm',
			format: 'a4',
		});

		const orderData = {
			'Customer Name': `${customerName}`,
			'Order Number': `${orderNo}`,
			'Coil Size': `${size}`,
			'Coil Serial Number': `${inputValue}`,
			'Checked By': `${modifiedBy.join(', ')}`,
			'Quality Completed Date': `${quality}`
		};

		const margin = 10;
		let yPosition = 20;

		// Title
		doc.setFontSize(14);
		doc.setTextColor(40);
		doc.text('Inspection Report', margin, yPosition);
		yPosition += 10;

		// Order Details Table
		doc.autoTable({
			startY: yPosition,
			head: [['Field', 'Value']],
			body: Object.entries(orderData),
			theme: 'grid',
			margin: { left: margin, right: margin },
			headStyles: {
				fillColor: [220, 220, 220], // dark grey
				textColor: [0, 0, 0],
				fontStyle: 'bold',
			},
			styles: {
				fontSize: 10,
				cellPadding: 3,
				overflow: 'linebreak',
				lineColor: [0, 0, 0],
				lineWidth: 0.2,
			},
			rowPageBreak: 'avoid',
		});

		yPosition += 60;


		const table = document.querySelector('#details');


		const head = [];
		const body = [];

		if (table) {
			const thead = table.querySelectorAll('thead tr');
			thead.forEach(row => {
				head.push([...row.cells].map(cell => cell.textContent.trim()));
			});

			const tbody = table.querySelectorAll('tbody tr');
			tbody.forEach(row => {
				body.push([...row.cells].map(cell => cell.textContent.trim()));
			});
		}

		// ✅ Use extracted head/body in autoTable
		doc.autoTable({
			startY: yPosition + 15,
			head,
			body,
			theme: 'grid',
			margin: { left: margin, right: margin },
			headStyles: {
				fillColor: [220, 220, 220],
				textColor: [0, 0, 0],
				fontStyle: 'bold',
			},
			styles: {
				fontSize: 10,
				cellPadding: 3,
				lineColor: [0, 0, 0],
				lineWidth: 0.2,
			},
			rowPageBreak: 'avoid', // ✅ now this works
		});


		// const head1 = [];
		// const body1 = [];

		// const table1 = document.querySelector('#checked');

		// if (table1) {
		// 	const thead = table1.querySelectorAll('thead tr');
		// 	thead.forEach(row => {
		// 		head1.push([...row.cells].map(cell => cell.textContent.trim()));
		// 	});

		// 	const tbody = table1.querySelectorAll('tbody tr');
		// 	tbody.forEach(row => {
		// 		body1.push([...row.cells].map(cell => cell.textContent.trim()));
		// 	});
		// }

		// doc.autoTable({
		// 	startY: yPosition-8,
		// 	head: head1,  // ✅ Use head1
		// 	body: body1,  // ✅ Use body1
		// 	theme: 'grid',
		// 	margin: { left: margin, right: margin },
		// 	headStyles: {
		// 		fillColor: [220, 220, 220],
		// 		textColor: [0, 0, 0],
		// 		fontStyle: 'bold',
		// 	},
		// 	styles: {
		// 		fontSize: 10,
		// 		cellPadding: 3,
		// 		lineColor: [0, 0, 0],
		// 		lineWidth: 0.2,
		// 	},
		// 	rowPageBreak: 'avoid',
		// });

		doc.setFontSize(12);
		doc.text('Issues List', 10, doc.lastAutoTable.finalY + 7);

		// Prepare data
		const issuesTableHead = [
			'S.No', 'Order No', 'Create Date', 'Issue Section', 'Issue Details', 'Remarks'
		];

		const issuesTableBody = issuesList.map((row, index) => ([
			index + 1,
			row.order_id || '',
			row.created_date || '',
			row.issue_section || '',
			row.issue_detail || '',
			row.remarks || '',
		]));

		// Render table
		doc.autoTable({
			startY: doc.lastAutoTable.finalY + 8,
			head: [issuesTableHead],
			body: issuesTableBody,
			theme: 'grid',
			margin: { left: margin, right: margin },
			headStyles: {
				fillColor: [220, 220, 220], // dark grey
				textColor: [0, 0, 0],
				fontStyle: 'bold',
			},
			styles: {
				fontSize: 9,
				cellPadding: 2,
				overflow: 'linebreak',
				lineColor: [0, 0, 0],
				lineWidth: 0.2,
			},
			rowPageBreak: 'avoid',
		});
		const sectionSummaryBody = Object.entries(enrichedGroupedRows).map(([section, rows]) => {
			const finalStatus = rows[0]?.finalStatus || 'Pending';
			return [section, finalStatus];
		});

		doc.setFontSize(12);
		doc.text('Section Summary', 10, doc.lastAutoTable.finalY + 7);

		doc.autoTable({
			startY: doc.lastAutoTable.finalY + 8,
			head: [['Section', 'Final Status']],
			body: sectionSummaryBody,
			theme: 'grid',
			margin: { left: margin, right: margin },
			headStyles: {
				fillColor: [220, 220, 220], // light grey
				textColor: [0, 0, 0],
				fontStyle: 'bold',
			},
			styles: {
				fontSize: 10,
				overflow: 'linebreak',
				cellPadding: 3,
				lineColor: [0, 0, 0],
				lineWidth: 0.2,
			},
			columnStyles: {
				1: { cellWidth: 60 }, // Optional: width for Final Status column
			},
			rowPageBreak: 'avoid',
		});



		// Save PDF
		doc.save('Inspection_Report.pdf');
	};
	const isValidDate = (date) => {
		return date && date !== "0000-00-00 00:00:00";
	};


	return (
		<div >

			<>
				<Container key={"orderView"} id="orderDetails" >
					<Grid container spacing={3}>
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<AutoCompleteOrder
								access={access}
								onSearchOrderId={handleSearchOrderId}
							/>
						</Grid>
					</Grid>
					<Grid container spacing={4} id="print-ignore">
						<Grid item xs={6}>
							<img
								src={logo}
								alt="Logo"
								style={{ width: "50%", height: "auto" }}
							/>
						</Grid>
						<Grid
							item
							xs={6}
							style={{
								display: "flex",
								justifyContent: "flex-end",
								alignItems: "center",
								gap: 15
							}}
						>
							<Box>
								<Grid>
									{qualityStatus === "1" && (
										<Grid >
											<Card className="quality-check-card">
												<Box className="quality-check-content">
													<img
														src={quality1}
														alt="Quality Check"
														className="quality-check-image"
													/>

													<Box className="quality-check-text-container">
														<Button
															color="info"
															className="quality-check-title"
															onClick={() => handleQualityCheckClick()}
														>
															Quality Check
														</Button>
													</Box>
												</Box>
											</Card>
										</Grid>
									)}
								</Grid>
							</Box>
							<Box sx={{ display: 'flex', gap: 2 }}>
								<Button
									type="primary"
									onClick={handleViewFile}
									style={{ backgroundColor: '#C5552C', color: "white" }}
								>
									View Files
								</Button>
								<Button
									style={{ backgroundColor: "#C5552C", color: "white" }}
									onClick={() => {
										generatePDF(orderNo);
									}}
									// onClick={() => {
									//     printPage();
									// }}
									variant="contained"
									startIcon={<PrintIcon />}
								>
									Print
								</Button>
							</Box>

						</Grid>
					</Grid>
					<Grid container spacing={2} columnGap={2} className="print-header">
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<img
								src={logo}
								alt="Logo"
								style={{ width: "50%", height: "50%" }}
							/>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						columnSpacing={2}
						columnGap={2}
						className="container"
						style={{
							padding: "10px",
							marginTop: "1.5em",
							tableLayout: "fixed",
						}}

					>
						<Typography className="heading" variant="h5">Order Details</Typography>
						<table
							border={1}
							cellPadding={1}
							cellSpacing={2}
							style={{ width: "inherit" }}

						>
							<thead>

								<tr>
									<th>Order No</th>
									<th>Date</th>
									<th>Customer</th>
									<th>Size</th>
									<th>Sq Feet</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{orderNo + splitId}</td>
									<td>{orderDate}</td>
									<td>{customerName}</td>
									<td>{size}</td>
									<td>{sqfeet}</td>
								</tr>
							</tbody>
						</table>
					</Grid>
					<Grid container spacing={2} sx={fixedLayout}  >
						<Grid item xs={6}>
							<Grid container spacing={2}>
								<Grid item xs={12}   >
									<Typography className="heading" variant="h6">End Plate</Typography>
									<table style={{ tableLayout: "fixed" }}>
										<tbody>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Material
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["epMaterial"]?.map((item) => {
														return (
															<>
																{endPlateMaterial &&
																	endPlateMaterial.includes(item.id)
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Model
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["epModal"]?.map((item) => {
														return (
															<>
																{endPlateModel &&
																	endPlateModel.includes(item.id)
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Orientation
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["oreientation"]?.map((item) => {
														return (
															<>
																{endPlateOrientation &&
																	endPlateOrientation.includes(item.id)
																	? item.lkp_value
																	: ""}
																<br />
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Cover Type
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													<Stack direction="row"  >
														{lookUpList["coverType"]?.map((item) => {
															return (
																<>
																	{lookUpList["coverDetail"]?.map((itemd) => {
																		if (
																			coverDetail !== undefined &&
																			itemd.lkp_id === item.id &&
																			coverDetail.indexOf(itemd.id) !== -1
																		) {
																			return (
																				<>
																					{itemd.sublkp_val}
																				</>
																			);
																		}
																	})}
																</>
															);
														})}
													</Stack>
												</td>
											</tr>
										</tbody>
									</table>
								</Grid>
								<Grid item xs={12}>
									<Typography className="heading" variant="h6">Pipe</Typography>
									<table id="specificTable" style={{ tableLayout: "fixed" }} >
										<tbody>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Pipe Type:
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["pipeType"]?.map((item) => {
														return (
															<>
																{pipeType && pipeType.includes(item.id)
																	? item.lkp_value
																	: null}
															</>
														);
													})}
												</td>
											</tr>

											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Pipe Bend:
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													<Stack
														direction="row"
														spacing={1}
														alignContent="space-between"
													>
														{pbStraight === "true" && (
															<Typography variant="subtitle1" gutterBottom>
																Straight
															</Typography>
														)}
														{pbSingle === "true" && (
															<Typography variant="subtitle1" gutterBottom>
																Single
															</Typography>
														)}
														{pbCross === "true" && (
															<Typography variant="subtitle1" gutterBottom>
																Cross
															</Typography>
														)}
														{pbOther === "true" && (
															<Typography variant="subtitle1" gutterBottom>
																Other
															</Typography>
														)}
													</Stack>
												</td>
											</tr>
										</tbody>
									</table>
								</Grid>
								<Grid item xs={12}>
									<Typography className="heading" variant="h6">Fins</Typography>
									<table id="specificTable" style={{ tableLayout: "fixed" }}>
										<tbody>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Fin per Inch
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{finPerInch}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Fin Thickness
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{description}
												</td>
											</tr>
										</tbody>
									</table>
								</Grid>
								<Grid item xs={12}>
									<Typography className="heading" variant="h6">Brazing</Typography>
									<table style={{ tableLayout: "fixed" }}>
										<tbody>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Circuit Model
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["circuitModel"]?.map((item) => {
														return (
															<>
																{circuitModels &&
																	circuitModels.indexOf(item.id) !== -1
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													No of circuit
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{noCircuit}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Liquid Line
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["liquidLine"]?.map((item) => {
														return (
															<>
																{liquidLine &&
																	liquidLine.indexOf(item.id) !== -1 &&
																	item.lkp_value}
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Discharge Line
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["dischargeLine"]?.map((item) => {
														return (
															<>
																{dischargeLine &&
																	dischargeLine.indexOf(item.id) !== -1
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
										</tbody>
									</table>
								</Grid>
								<Grid item xs={12}>
									<Typography className="heading" variant="h6">
										Paint,Packing and Dispatch
									</Typography>
									<table style={{ tableLayout: "fixed" }}>
										<tbody>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Paint
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["paintType"]?.map((item) => {
														return (
															<>
																{paintType && paintType.includes(item.id)
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>

											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Packing
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["packingType"]?.map((item) => {
														return (
															<>
																{packingType && packingType.includes(item.id)
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
											<tr>
												<th style={{ textAlign: "left", paddingLeft: "10px" }}>
													Dispatch
												</th>
												<td style={{ textAlign: "left", paddingLeft: "10px" }}>
													{lookUpList["dispatchMode"]?.map((item) => {
														return (
															<>
																{dispatchMode && dispatchMode.includes(item.id)
																	? item.lkp_value
																	: ""}
															</>
														);
													})}
												</td>
											</tr>
										</tbody>
									</table>
								</Grid>
							</Grid>
						</Grid>

						<Grid item xs={6}>
							<Grid container>
								<Grid item xs={12}>
									<>
										{
											<ImageList cols={1} rowHeight={200}>
												{epPhoto?.map((item, index) => (
													<ImageListItem key={"epphoto" + index}>
														<img
															src={imageURL + item}
															srcSet={imageURL + item}
															alt={"EpPhoto"}
															loading="lazy"
															style={{
																maxWidth: "100%",
																maxHeight: "100%",
																verticalAlign: "middle",
																objectFit: "contain",
															}}

														/>
														<IconButton
															className="order-view-img"
															onClick={() =>
																handleClickOpenimg(imageURL + item)
															}
														>
															<PreviewIcon />
														</IconButton>
													</ImageListItem>
												))}
											</ImageList>
										}
									</>
								</Grid>
								<Grid item xs={12}>
									<>
										{
											<ImageList cols={1} rowHeight={250}>
												{assemblyPhoto?.map((item, index) => (
													<ImageListItem key={"assembly" + index}>
														<img
															src={imageURL + item}
															srcSet={imageURL + item}
															alt={"assembly"}
															loading="lazy"
															style={{
																maxWidth: "100%",
																maxHeight: "100%",
																verticalAlign: "middle",
																objectFit: "contain",
															}}
														/>
														<IconButton
															className="order-view-img"
															onClick={() =>
																handleClickOpenimg(imageURL + item)
															}
														>
															<PreviewIcon />
														</IconButton>
													</ImageListItem>
												))}
											</ImageList>
										}
									</>
								</Grid>
								<Grid item xs={12}>
									<>
										{
											<ImageList cols={1} rowHeight={"25%"}>
												{brazingPhoto?.map((item, index) => (
													<ImageListItem key={"brazing" + index}>
														<img
															src={imageURL + item}
															srcSet={imageURL + item}
															alt={"Brazing"}
															loading="lazy"
															style={{
																maxWidth: "100%",
																maxHeight: "100%",
																verticalAlign: "middle",
																objectFit: "contain",
															}}
														/>
														<IconButton
															onClick={() =>
																handleClickOpenimg(imageURL + item)
															}
														>
															<PreviewIcon />
														</IconButton>
													</ImageListItem>
												))}
											</ImageList>
										}
									</>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<div className="print-page-break"></div>
					<Grid container spacing={2} columnGap={2} className="print-header">
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<img
								src={logo}
								alt="Logo"
								style={{ width: "50%", height: "50%" }}
							/>
						</Grid>
					</Grid>
					<Grid item xs={12} className="page-break" id="coilDetails">
						<Typography className="heading" variant="h5">Coil Details</Typography>
						<table style={{ tableLayout: "fixed" }}>
							<thead>
								<tr>
									<th>Process</th>
									<th>Date & Time</th>
									<th>Comments</th>
								</tr>
							</thead>
							<tbody>
								{
									<tr>
										<th style={{ textAlign: "left" }}>CNC Nesting</th>
										<td>{formatDateIst(cncNestingDate)}</td>
									</tr>
								}

								{
									<tr>
										<th style={{ textAlign: "left" }}>CNC Program Created</th>
										<td>{formatDateIst(cncNestingStatusDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											Program Number-{cncNestingPgm}
										</td>
									</tr>
								}

								{
									<tr>
										<th style={{ textAlign: "left" }}>
											CNC end plate punching
										</th>
										<td>{formatDateIst(cncPunchingDate)}</td>
									</tr>
								}

								{
									<tr>
										<th style={{ textAlign: "left" }}>End plate bending</th>
										<td>{formatDateIst(bendingDate)}</td>
									</tr>
								}

								{
									<tr>
										<th style={{ textAlign: "left" }}>
											Tray/Fan Cover Bending
										</th>
										<td>{formatDateIst(bendingDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											Comments: {epComments}
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Copper tube Cutting</th>
										<td>{formatDateIst(tCuttingDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>Roll Number: {tCuttingRollNo}</span>
											{pbStraight == "true" && (
												<span>
													Pipe Straight-{pbStraightQty} Nos {pbStraightSize}mm
												</span>
											)}
											{pbCross == "true" && (
												<span>
													Pipe Cross-{pbCrossQty} Nos {pbCrossSize}mm
												</span>
											)}
											{pbSingle == "true" && (
												<span>
													Pipe Single-{pbSingleQty} Nos {pbSingleSize}mm
												</span>
											)}
											{pbOther == "true" && (
												<span>
													Pipe Others-{pbOtherQty} Nos {pbOtherSize}mm
												</span>
											)}
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Copper tube Bending </th>
										<td>{formatDateIst(tCuttingDateTime)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											Comments-{pipeComment}
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Fins Punching</th>
										<td>{formatDateIst(finPunchDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>
												Foil Number:{finFoilNo ? finFoilNo : " No Roll no"}
											</span>
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Coil Assembly</th>
										<td>{formatDateIst(caStatusDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>Comments-{finComments}</span>
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Coil Expansion</th>
										<td>{formatDateIst(brazingExpansion)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>
												Expansion Type:{" "}
												{lookUpList["expansionType"]?.map((item) => {
													return (
														<>
															{expansionType && expansionType.includes(item.id)
																? item.lkp_value
																: ""}
														</>
													);
												})}
											</span>
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>
											Coil Brazing & Leak Testing
										</th>
										<td>{formatDateIst(brazingDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											{" "}
											Comments: {brazingComments}
										</td>
									</tr>
								}

								{
									<tr>
										<th style={{ textAlign: "left" }}>Painting</th>
										<td>{formatDateIst(ppDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>
												Painting Type:{" "}
												{lookUpList["paintType"]?.map((item) => {
													return (
														<>
															{paintType && paintType.includes(item.id)
																? item.lkp_value
																: ""}
														</>
													);
												})}
											</span>
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>Packing</th>
										<td>{formatDateIst(ppStatusDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											<span>
												Packing Type:{" "}
												{lookUpList["packingType"]?.map((item) => {
													return (
														<>
															{packingType && packingType.includes(item.id)
																? item.lkp_value
																: ""}
														</>
													);
												})}
											</span>
										</td>
									</tr>
								}
								{
									<tr>
										<th style={{ textAlign: "left" }}>
											Quality
										</th>
										<td>{formatDateIst(quality)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											{" "}
											Comments:
										</td>
									</tr>
								}



								{
									<tr>
										<th style={{ textAlign: "left" }}>Dispatch</th>
										<td>{formatDateIst(dispatchDate)}</td>
										<td
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												border: "0",
											}}
										>
											{dispatchComment}
										</td>
									</tr>
								}
							</tbody>
						</table>
					</Grid>
					<div className="print-page-break"></div>
					<Grid container spacing={2} columnGap={2} className="print-header">
						<Grid
							item
							xs={12}
							style={{ display: "flex", justifyContent: "center" }}
						>
							<img
								src={logo}
								alt="Logo"
								style={{ width: "50%", height: "50%" }}
							/>
						</Grid>
					</Grid>
					<Grid container  >
						<Grid item xs={12}>
							<Typography className="heading" variant="h5" style={{ marginBottom: 10 }}>
								Brazing & Leak Testing Details
							</Typography>
						</Grid>
						<table></table>
						{brazingDetails &&
							brazingDetails.map((value, index) => (

								<React.Fragment key={index}>
									{/* Brazing & Leak Testing Details */}
									<Grid item xs={6}>
										<div>
											<h6>Table {index + 1}</h6>
											<table style={{ tableLayout: "fixed" }}>
												<tbody>
													<tr>
														<th
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															Serial No
														</th>
														<td
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															{value.series_ref}
														</td>
													</tr>
													<tr>
														<th
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															Leak Date
														</th>
														<td
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															{console.log(value.completion)}
															{value.completion}
														</td>
													</tr>
													<tr>
														<th
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															Leak Details
														</th>
														<td
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															{value.A !== "0" ? "A:" + value.A + " " : ""}
															{value.B !== "0" ? "B:" + value.B + " " : ""}
															{value.D !== "0" ? "D:" + value.D + " " : ""}
															{value.E !== "0" ? "E:" + value.E + " " : ""}
															{value.F !== "0" ? "F:" + value.F + " " : ""}
															{value.G !== "0" ? "G:" + value.G + " " : ""}
															{value.H !== "0" ? "H:" + value.H + " " : ""}
															{value.K !== "0" ? "K:" + value.K + " " : ""}
															{value.L !== "0" ? "L:" + value.L + " " : ""}
															{value.N !== "0" ? "N:" + value.N + " " : ""}
														</td>
													</tr>
													<tr>
														<th
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															Workman Details
														</th>
														<td
															style={{ textAlign: "left", paddingLeft: "10px" }}
														>
															{value.uBend !== ""
																? "U-Bend:" + value.uBend + " "
																: ""}
															{value.inletOutlet !== ""
																? "Inlet-Outlet:" + value.inletOutlet + " "
																: ""}
															{value.headder !== ""
																? "Headder:" + value.headder + " "
																: ""}
															{value.headderFix !== ""
																? "Headder Fix:" + value.headderFix + " "
																: ""}
															{value.distributor !== ""
																? "Distributor:" + value.distributor + " "
																: ""}
															{value.distributorFix !== ""
																? "Distributor Fix:" +
																value.distributorFix +
																" "
																: ""}
														</td>
													</tr>
													{/* Additional details */}
												</tbody>
											</table>
										</div>
									</Grid>

									{/* Corresponding Image */}
									<Grid item xs={6}>
										{brazingTestingImages &&
											brazingTestingImages[value.series_id] && (
												<ImageList cols={1} rowHeight={200}>
													{brazingTestingImages[value.series_id]?.map(
														(item, index) => (
															<ImageListItem key={"brazing_testing" + index}>
																<img
																	src={imageURL + item}
																	srcSet={imageURL + item}
																	alt={"BrazingTesting"}
																	loading="lazy"
																	style={{
																		maxWidth: "100%",
																		maxHeight: "100%",
																		objectFit: "contain",
																	}}
																/>
																<IconButton
																	className="order-view-img"
																	onClick={() =>
																		handleClickOpenimg(imageURL + item)
																	}
																>
																	<PreviewIcon />
																</IconButton>
															</ImageListItem>
														)
													)}
												</ImageList>
											)}
									</Grid>
								</React.Fragment>
							))}
					</Grid>
				</Container>
			</>
			<Dialog
				fullScreen
				open={openImg}
				TransitionComponent={Transition}
				keepMounted
				onClose={handleCloseImg}
				aria-describedby="alert-dialog-slide-description"
			>
				<AppBar sx={{ position: "relative" }}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleCloseImg}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
							Order View Images
						</Typography>
					</Toolbar>
				</AppBar>
				<img
					src={dialogImg}
					srcSet={dialogImg}
					alt={dialogImg}
					loading="lazy"
				/>
				<DialogActions>
					<Button onClick={() => handleCloseImg("yes")}>Close</Button>
				</DialogActions>
			</Dialog>


			<Dialog
				open={isModalVisible}
				onClose={handleCancel}
				maxWidth="md"
				fullWidth
			>
				<DialogTitle sx={{ m: 0, p: 2 }}>
					File Viewer
					<IconButton
						aria-label="close"
						onClick={handleCancel}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				{/* <Box sx={{ p: 2 }}>
					<ImageList cols={1} rowHeight="auto" gap={16}>
						{fileUrls.map((url, index) => (
							<ImageListItem key={`file${index}`} sx={{
								overflow: 'hidden',
								borderRadius: '8px',
								boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
							}}>
								<img
									src={url}
									alt={`File Preview ${index}`}
									style={{
										width: '100%',
										maxHeight: '70vh',
										objectFit: 'contain'
									}}
								/>
							</ImageListItem>
						))}
					</ImageList>
				</Box> */}

				<Box sx={{ p: 2 }}>
					<UniversalFileViewer fileUrls={fileUrls} />
				</Box>

			</Dialog>


			<Dialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				maxWidth="xxl"
				fullWidth
				scroll="paper"
			>
				<DialogTitle sx={{ fontWeight: 'bold', color: '#d96e27', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					View Inspection Report
					<Button
						style={{ backgroundColor: "#C5552C", color: "white" }}
						onClick={() => handlePrintInspectionReport()}
						variant="contained"
						startIcon={<PrintIcon />}
					>
						Print
					</Button>
				</DialogTitle>



				<DialogContent dividers>
					<Paper elevation={3} sx={{ backgroundColor: '#f8f9fa', p: 2 }}>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={6}>
								<Typography className="reports">
									<strong>Customer Name:</strong> {customerName}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Typography className="reports">
									<strong>Order Number:</strong> {orderNo + splitId}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Typography className="reports">
									<strong>Coil Size:</strong> {size}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Box
									sx={{
										backgroundColor: '#d96e27',
										p: 1,
										color: 'white',
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
									}}
								>
									<Typography
										sx={{
											display: 'flex',
											flexDirection: { xs: 'column', sm: 'row' },
											alignItems: 'center',
											gap: 1,
										}}
									>
										<strong>Coil Serial Number:</strong>
										<Select
											size="small"
											value={inputValue}
											onChange={(e) => setInputValue(e.target.value)}
											displayEmpty
											variant="outlined"
											sx={{ backgroundColor: 'white', minWidth: 150 }}
										>
											<MenuItem value="" disabled>Select Quantity</MenuItem>
											{(serialNumberOptions?.length > 0
												? serialNumberOptions
												: sizeOptions
											).map((item) => (
												<MenuItem
													key={item.id ?? item}
													value={item.id ?? item}
												>
													{item.label ?? item}
												</MenuItem>
											))}
										</Select>
									</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Typography className="reports">
									<strong>Quality Completed Date:</strong> {quality}
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<Typography className="reports">
									<strong>Checked By:</strong>{' '}
									{modifiedBy.map((name, index) => (
										<React.Fragment key={index}>
											{name}
											{index < modifiedBy.length - 1 && ', '}
										</React.Fragment>
									))}

								</Typography>
							</Grid>
						</Grid>
					</Paper>
					{/* <TableContainer component={Paper} sx={{ mt: 3 }}>
						<Table id="checked" size="small" sx={{
							borderCollapse: 'collapse',
							'& th, & td': {
								border: '1px solid black',
							},
						}}>
							<TableHead>
								<TableRow>
									<TableCell>Date</TableCell>
									<TableCell>Measurement</TableCell>
									<TableCell>Checked By</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{inspectionList.map((row, index) => (
									<TableRow key={index}>
										<TableCell>
											{isValidDate(row.updated_date)
												? row.updated_date
												: row.created_date}
										</TableCell>
										<TableCell>{row.measurement}</TableCell>
										<TableCell>{row.modified_by || "-"}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer> */}
					<TableContainer component={Paper} sx={{ mt: 3 }}>
						<Table id="details" size="medium" aria-label="inspection table" sx={{

							borderCollapse: 'collapse', // ensures proper border rendering
							'& th, & td': {
								border: '1px solid black', // optional: borders for internal cells
							},
						}}>
							<TableHead>
								<TableRow>
									<TableCell><strong>Description</strong></TableCell>
									<TableCell><strong>Specification</strong></TableCell>
									<TableCell><strong>Status</strong></TableCell>
									<TableCell><strong>Remarks</strong></TableCell>
									<TableCell><strong>Section</strong></TableCell>
									<TableCell><strong>Final Status</strong></TableCell>
								</TableRow>
							</TableHead>

							<TableBody>
								{Object.entries(enrichedGroupedRows).map(([sectionName, sectionRows]) =>
									sectionRows.map((row, index) => (
										<TableRow key={row.id || `${sectionName}-${index}`}>
											<TableCell>{row.description}</TableCell>
											<TableCell>{row.specification}</TableCell>
											<TableCell>{row.status}</TableCell>
											<TableCell>{row.remarks}</TableCell>

											{index === 0 && (
												<TableCell
													rowSpan={sectionRows.length}
													align="center"
													sx={{
														verticalAlign: 'middle',
														fontWeight: 'bold',
														backgroundColor: '#f4f4f4'
													}}
												>
													{sectionName}
												</TableCell>
											)}

											{index !== 0 && null}

											{index === 0 && (
												<TableCell
													rowSpan={sectionRows.length}
													align="center"
													sx={{
														verticalAlign: 'middle',
														fontWeight: 'bold',
														backgroundColor: '#f4f4f4'
													}}
												>
													{sectionRows[0].finalStatus} {/* or sectionFinalStatus if available separately */}
												</TableCell>
											)}

											{row.modified_by}
										</TableRow>
									))
								)}
							</TableBody>

						</Table>
					</TableContainer>

					<Paper elevation={3} sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fa' }}>
						<Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
							Section Summary
						</Typography>
						<Grid container spacing={2}>
							{Object.entries(enrichedGroupedRows).map(([section, rows], index) => {
								const finalStatus = rows[0]?.finalStatus || 'Pending';
								const bgColor =
									finalStatus === 'Pass'
										? '#d8e4bc'
										: finalStatus === 'Fail'
											? '#f2dcdb'
											: '#f0f0f0';

								const textColor =
									finalStatus === 'Pass'
										? '#006100'
										: finalStatus === 'Fail'
											? '#9c0006'
											: '#808080';

								return (
									<Grid item xs={4} key={index}>
										<Box
											sx={{
												p: 1,
												bgcolor: bgColor,
												borderRadius: 1,
												textAlign: 'center',
											}}
										>
											<Typography sx={{ fontWeight: 'bold' }}>
												{section}:{' '}
												<span style={{ color: textColor }}>{finalStatus}</span>
											</Typography>
										</Box>
									</Grid>
								);
							})}
						</Grid>
					</Paper>

					<Paper elevation={3} sx={{ mt: 3, p: 2, backgroundColor: '#f8f9fa' }}>
						<Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
							Issues List
						</Typography>
						<DataGrid
							rows={issuesList}
							getRowHeight={() => 'auto'}
							columns={[
								{ field: 'sno', headerName: 'S.No', width: 70, align: 'center', headerAlign: 'center' },
								{ field: 'order_id', headerName: 'Order NO', width: 200, headerAlign: 'center' },
								// {
								//     field: 'file_name',
								//     headerName: 'Images',
								//     width: 150,
								//     headerAlign: 'center',
								//     align: 'center',
								//     renderCell: (params) => {
								//         let imageUrls = [];

								//         try {
								//             imageUrls = JSON.parse(params.value);
								//         } catch (error) {
								//             console.error('Invalid image URL JSON:', error);
								//         }

								//         return imageUrls.length > 0 ? (
								//             <Button
								//                 variant="text"
								//                 color="primary"
								//                 onClick={() => handleOpen(imageUrls)}
								//                 size="small"
								//             >
								//                 View Images
								//             </Button>
								//         ) : (
								//             <span>No Image</span>
								//         );
								//     }
								// },
								{ field: 'created_date', headerName: 'Create Date', width: 200, headerAlign: 'center' },
								{ field: 'issue_section', headerName: 'Issue Section', width: 150, align: 'center', headerAlign: 'center' },
								{
									field: 'issue_detail', headerName: 'Issue Details', width: 200, headerAlign: 'center',
									renderCell: (params) => {
										const value = params.formattedValue || '';

										return (
											<div className={'issueRemarkScroll'} >
												{value}
											</div>
										);
									}
								},
								// { field: 'remarks', headerName: 'Remarks', width: 400, headerAlign: 'center' },

								{
									field: 'remarks',
									headerName: 'Remarks',
									width: 400,
									headerAlign: 'center',
									align: 'center',
									renderCell: (params) => {
										const value = params.formattedValue || '';
										// const isScrollable = value.length > 30;
										return (
											<div className={'issueRemarkScroll'}>
												{value}
											</div>
										);
									}
								},


							]}
							autoHeight
							disableSelectionOnClick
							sx={{
								"& .MuiDataGrid-columnHeader": {
									backgroundColor: "#d96e27",
									color: "white",
								},
								".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell": {
									whiteSpace: "break-spaces",
									padding: 0,
									display: "flex",
									justifyContent: "center",
									fontSize: "0.75rem",
								},
								'& .MuiDataGrid-cell': {
									display: 'flex',
									justifyContent: 'center', // Horizontal center
									alignItems: 'center',     // Vertical center
									textAlign: 'center',
									whiteSpace: 'pre-wrap',
									wordBreak: 'break-word',
									lineHeight: '1.5rem',
								},
								'& .MuiDataGrid-columnHeaders': {
									minHeight: '56px !important',
									maxHeight: '56px !important',
								},
								'& .MuiDataGrid-columnHeaderTitle': {
									width: '100%',
									textAlign: 'center',
									fontWeight: 600,
								},
							}}
						/>
					</Paper>

				</DialogContent>

				<DialogActions>
					<Button onClick={() => setOpenDialog(false)} color="secondary">
						Close
					</Button>
				</DialogActions>
			</Dialog>



		</div>
	);
}
